module.exports = __webpack_public_path__ + "img/eat1.52a81c6c.png";